import withStyles from '@mui/styles/withStyles';
import React from "react";

import { OrderProductStatus } from "../../../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    minWidth: "51px",
    padding: "6px 16px",
    height: "40px",
    borderRadius: "20px",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
  },
});

const SimpleBadge = (props: Props) => {
  const { classes, value } = props;
  return (
    <div className={classes.customBadge}>
      <span className={classes.textValue}>{value}</span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const BadgeJobStatus = (props: Props) => {
  const { value } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return <StyledBadge backgroundColor={backgroundColor} textColor={textColor} value={value} />;
    return <> </>;
  };

  switch (value) {
    case OrderProductStatus.TO_BE_PICKED:
      return renderBadge("#E0F2FE", "#0BA5EC", value);
    case OrderProductStatus.SCANNED:
      return renderBadge("#D1FADF", "#12B76A", value);
    default:
      return renderBadge("#E0F2FE", "#0BA5EC", value);
  }
};

export default BadgeJobStatus;
